<template>
    <div class="w-full">
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <form id="smmr-form" @submit.prevent="update">
            <div class="p-8 flex flex-wrap" @change="dirtyForm()">
                <text-input v-model="form.name" :error="form.errors?.name" class="pr-6" label="* Name" @update:modelValue="value = $event" />
                <text-input v-model="form.position" :error="form.errors?.position" class="pr-6" label="* Position" @update:modelValue="value = $event" />
                <text-input v-model="form.org" :error="form.errors?.org" class="pr-6" label="* Organisation" @update:modelValue="value = $event" />
                <text-input v-model="form.email" :error="form.errors?.email" class="pr-6" label="* Email" @update:modelValue="value = $event" />
                <text-input v-model="form.address_line1" :error="form.errors?.address_line1" class="pr-6" label="* Address Line 1"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.address_line2" :error="form.errors?.address_line2" class="pr-6" label="* Address Line 2"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.address_line3" :error="form.errors?.address_line3" class="pr-6" label="Address Line 3"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.city_town" :error="form.errors?.city_town" class="pr-6" label="* Town / City" @input="form.city_town = $event.target.value" />
                <text-input v-model="form.county_state" :error="form.errors?.county_state" class="pr-6" label="* County / State"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.post_zip_code" :error="form.errors?.post_zip_code" class="pr-6" label="* Post / Zip Code"
                            @update:modelValue="value = $event"
                />
                <select-input v-model="form.country_id" :error="form.errors?.country_id" class="pr-6" label="* Country" @update:modelValue="value = $event">
                    <option v-for="(country, reference) in countries_of_domicile" :key="reference" :value="country.reference">{{ country.name }}</option>
                </select-input>
                <text-input v-model="form.phone_number" :error="form.errors?.phone_number" class="pr-6" label="* Phone Number" @update:modelValue="value = $event" />
            </div>
            <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
            <div v-if="serverErrors" class="m-8 server-error">
                <p class="server-error">There were some validation issues, please check the fields above</p>
            </div>
            <div class="lg:flex justify-end w-full pb-2 -mt-8">
                <div class="relative w-auto lg:w-1/3 mx-8">
                    <application-component-save-button :disabled="formDirty"
                                                       class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                       type="submit"
                    >
                        Save Contact Details
                        <div v-if="loading" class="lds-ring-container absolute top-10">
                            <div class="lds-ring">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    </application-component-save-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextInput from '../../shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    name: 'RefereeForm',
    components: {
        TextInput,
        SelectInput,
        ApplicationComponentSaveButton,
    },
    metaInfo: {title: 'Referee Portal'},

    props: {
        displayData: Object,
        refereeData: Object,
    },
    data() {
        return {
            personalDetailsShow: false,
            referenceDetailsShow: true,
            documentationShow: false,
            userData: {},
            referenceData: null,
            locked: false,
            form: {
                reference: this.refereeData.reference,
                title: this.refereeData.title,
                name: this.refereeData.name,
                position: this.refereeData.position,
                org: this.refereeData.org,
                email: this.refereeData.email,
                address_line1: this.refereeData.address_line1,
                address_line2: this.refereeData.address_line2,
                address_line3: this.refereeData.address_line3,
                city_town: this.refereeData.city_town,
                county_state: this.refereeData.county_state,
                post_zip_code: this.refereeData.post_zip_code,
                country_id: this.refereeData.country_id,
                phone_number: this.refereeData.phone_number,
                application_id: this.applicationReference,
                errors: {
                },
            },

            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            template: null,
            scoreOptions: [5, 4, 3, 2, 1, 0],
            scoreLabels: ['Excellent', 'Very Good', 'Good', 'Fair', 'Poor', 'Unable to comment'],
            scoreOptionsSmall: [1, 2, 3, 4],
            overallRecommendationOptions: ['Unable to comment', 'Do not recommend this applicant', 'Recommend this applicant', 'Strongly recommend this applicant'],
            academicOptions: ['Unable to comment', 'Below Average', 'Average', 'Above Average', 'Outstanding: top 5%'],
            documentTypes: [],
            documents: [],
            referenceDocType: null,
            applicationId: null,
            countries_of_domicile: this.refereeData.countries_of_domicile,

        }
    },
    computed: {
        validationErrors: {
            get: function () {
                return this.form.errors
            },
            set: function (newValue) {
                for (const key in newValue) {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    watch: {
        getDocumentTypesByPortalToken(data) {
            this.documentTypes = data
        },
    },
    methods: {
        update() {
            this.loading = true
                this.$store.dispatch('updateRefereeDetails', {
                    reference: this.$route.params.id,
                    token: this.$route.params.token,
                    refereeData: this.form,
                })
                    .then((response) => {
                        this.loading = false
                        this.serverErrors = ''
                        this.form.errors = {}
                        this.successMessage = response.data
                        setTimeout(() => {
                            this.referenceDetailsShow = true
                            this.personalDetailsShow = false
                            this.serverErrors = ''
                            this.successMessage = ''

                        }, 3000)


                    })
                    .catch(error => {
                        this.loading = false
                        this.serverErrors = Object.values(error.response.data.errors)
                        this.form.errors = error.response.data.errors
                        this.validationErrors = error.response.data.errors
                        this.successMessage = ''
                    })
            this.formDirty = false
            this.$emit('formDirty', false)
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
            this.$emit('formDirty', true)
        },
    },
}
</script>

<style scoped>
.hide {
    display: none !important;
}
</style>


